export const SETTINGS_PERMISSIONS_COLUMNS = [
  { key: "full_access", label: "Full Access" },
  { key: "create", label: "Create" },
  { key: "view", label: "View" },
  { key: "edit", label: "Edit/Update" },
  { key: "delete", label: "Delete/Deactivate" }
] as const

export const SETTINGS_PERMISSIONS_MATRIX_COLUMNS = [
  { key: "view", labelKey: "permissions.editor.columnView" },
  { key: "create", labelKey: "permissions.editor.columnCreate" },
  { key: "edit", labelKey: "permissions.editor.columnEdit" },
  { key: "delete", labelKey: "permissions.editor.columnDelete" },
  { key: "full_access", labelKey: "permissions.editor.columnFullAccess" }
] as const
